import { Inject, Pipe, PipeTransform } from '@angular/core';

import { TranslationService } from './translation.service';

@Pipe ({
    name: 'translate',
    standalone: false
})
export class TranslationPipe implements PipeTransform
{
  constructor(@Inject(TranslationService) private translationService) {}

  public transform (key: string, value: string|undefined,
      replacements?: Record<string, string|undefined>): string
  {
    if (value === undefined) {
      value = '1';
    }
    return this.translationService.get(key.trim(), value, replacements);
  }
}
